import { ConfigurationProfilesController } from '../controller/ConfigurationProfilesController';
import { BaseWebComponentElement } from '../../../framework/BaseWebComponentElement';

export class ConfigurationProfilesWebComponent extends BaseWebComponentElement {
  constructor() {
    super();
    this.initialSetup({
      controllerConstructor: ConfigurationProfilesController,
    });
  }
}
